import React, { useState, useRef } from "react";
import axios from "axios";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Col,
  Input,
  Alert,
  Spinner
} from "reactstrap";
import { useHistory } from "react-router-dom";

const ENDPOINT = "https://lotogreen.bet.br/api/auth/password/email";

const COLORS = {
  bg: "#0B0B0F",
  surface: "#121317",
  text: "#ECECF3",
  subtext: "#A3A6AF",
  border: "#26272B",
  primary: "#6f42c1",
  primaryHover: "#5b32a8",
};

export default function ForgotPassword() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ type: "", message: "" });
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);

  const isValidEmail = (v) => /^\S+@\S+\.\S{2,}$/.test(v.trim());

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isValidEmail(email) || loading) return;

    setLoading(true);
    setAlert({ type: "", message: "" });

    try {
      await axios.post(
        ENDPOINT,
        { email: email.trim() },
        { headers: { "Content-Type": "application/json" } }
      );

      setAlert({
        type: "success",
        message:
          "Caso seu e-mail esteja cadastrado, você receberá um link de recuperação em breve. ⚠️ O e-mail de recuperação chegará com a identidade da Lotogreen.",
      });
    } catch {
      setAlert({
        type: "danger",
        message:
          "Não foi possível enviar agora. Verifique o e-mail e tente novamente em instantes.",
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <div
      className="d-flex justify-content-center mt-4"
      style={{ minHeight: "100vh", background: COLORS.bg, color: COLORS.text }}
    >
      <Col className="px-3" xs="12" sm="10" md="7" lg="5" xl="4">
        <Card
          className="shadow-lg border-0"
          style={{ background: COLORS.surface, borderRadius: 16 }}
        >
          <form onSubmit={handleSubmit}>
            <CardHeader
              style={{
                background: COLORS.surface,
                borderBottom: `1px solid ${COLORS.border}`,
              }}
            >
              <CardTitle tag="h4" style={{ color: COLORS.text }}>
                Recuperar Senha
              </CardTitle>
              <p style={{ color: COLORS.subtext, fontSize: 14, margin: 0 }}>
                Enviaremos o link de recuperação para seu e-mail cadastrado.
              </p>
            </CardHeader>

            <CardBody>
              {alert.message && (
                <Alert
                  color={alert.type}
                  className="py-2"
                  style={{
                    background: COLORS.surface,
                    color: COLORS.text,
                    border: `1px solid ${COLORS.border}`,
                  }}
                >
                  {alert.message}
                  {alert.type === "success" && (
                    <div style={{ color: COLORS.subtext, fontSize: 13 }}>
                      Dica: verifique também sua caixa de spam.
                    </div>
                  )}
                </Alert>
              )}

              <label htmlFor="email" style={{ color: COLORS.subtext }}>
                E-mail cadastrado
              </label>
              <Input
                id="email"
                type="email"
                innerRef={inputRef}
                placeholder="seuemail@dominio.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
                style={{
                  height: 54,
                  background: COLORS.bg,
                  color: COLORS.text,
                  border: `1px solid ${COLORS.border}`,
                  boxShadow: "none",
                }}
                className="mb-3"
              />

              <Button
                type="submit"
                className="w-100"
                style={{
                  height: 52,
                  fontWeight: 600,
                  background: isValidEmail(email)
                    ? COLORS.primary
                    : COLORS.surface,
                  color: isValidEmail(email) ? "#FFF" : COLORS.subtext,
                  border: "none",
                }}
                disabled={!isValidEmail(email) || loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" /> Enviando…
                  </>
                ) : (
                  "Enviar e-mail de recuperação"
                )}
              </Button>
            </CardBody>

            <CardFooter
              style={{
                background: COLORS.surface,
                borderTop: `1px solid ${COLORS.border}`,
                textAlign: "center",
              }}
            >
              <p style={{ color: COLORS.subtext }}>
                Lembrou da senha?{" "}
                <span
                  onClick={() => history.push("/login")}
                  style={{
                    color: COLORS.primary,
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  Fazer login
                </span>
              </p>
              <p style={{ color: COLORS.subtext }}>
                Não tem conta?{" "}
                <span
                  onClick={() => history.push("/register/ROLE_LOTOGREEN")}
                  style={{
                    color: COLORS.primary,
                    cursor: "pointer",
                    fontWeight: 600,
                  }}
                >
                  Criar agora
                </span>
              </p>
            </CardFooter>
          </form>
        </Card>
      </Col>
    </div>
  );
}
